import { SVGProps } from 'react';

const RailSymbol = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 15h14M5 9h14m-5 11-5-5 6-6-5-5"
    />
  </svg>
);
export default RailSymbol;
